(function () {
  'use strict';

  if (window.__CL_WEB_SIGNALS_V2__) return;
  window.__CL_WEB_SIGNALS_V2__ = true;

  // Enable only after API metric successors and their exclusion tests pass.
  var DIRECT_RELEASE_READY = true;
  var THEME_ID = '205747618078';
  var SHOP = 'j0pgjz-sq.myshopify.com';
  var HOSTS = ['chris-lake.com', 'www.chris-lake.com'];
  var BUILD = 'cl-web-signals-20260924-direct-v10';
  var ATTRIBUTION_KEY = 'cl_web_signal_attribution_v2';
  var SENT_KEY = 'cl_web_signal_direct_receipts_v1';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;
  var leftSent = false;
  var hiddenTimer = null;
  var engaged = false;
  var navigating = false;
  var activeElapsedMs = 0;
  var activeStartedAt = document.visibilityState === 'hidden' ? null : Date.now();
  var engagementTimer = null;
  var VIDEO_THRESHOLD_SECONDS = 30;
  var VIDEO_THRESHOLD_PERCENT = 0.5;

  function isProduction() {
    try {
      var shopify = window.Shopify;
      return Boolean(
        DIRECT_RELEASE_READY && shopify &&
        shopify.shop === SHOP &&
        shopify.theme &&
        String(shopify.theme.id) === THEME_ID &&
        shopify.theme.role === 'main' &&
        HOSTS.indexOf(window.location.hostname) !== -1 &&
        window.location.protocol === 'https:' &&
        !shopify.designMode &&
        !shopify.visualPreviewMode &&
        !shopify.inspectMode &&
        !['preview_theme_id', 'preview', '_fd', 'preview_script_id'].some(function (key) {
          return new URL(window.location.href).searchParams.has(key);
        })
      );
    } catch (error) {
      return false;
    }
  }

  function marketingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        typeof privacy.marketingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true &&
        privacy.marketingAllowed() === true
      );
    } catch (error) {
      return false;
    }
  }

  function safe(value) {
    var text = String(value || '').trim();
    return text.length <= 300 ? text : text.slice(0, 300);
  }

  function validEmail(value) {
    var email = safe(value).toLowerCase();
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? email : '';
  }

  function readStorage(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key) || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function writeStorage(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function id() {
    return window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
  }

  function pageHandle() {
    if (window.__CL_PAGE_HANDLE__) return safe(window.__CL_PAGE_HANDLE__);
    return safe(window.location.pathname.replace(/^\/+|\/+$/g, '').replace(/\//g, '_')) || 'home';
  }

  function pageType() {
    var path = window.location.pathname.toLowerCase();
    if (path === '/' || path === '') return 'home';
    if (/^\/products\//.test(path)) return 'product';
    if (/^\/collections\//.test(path)) return 'collection';
    if (/^\/blogs\//.test(path)) return 'article';
    if (/^\/pages\//.test(path)) return 'page';
    if (/^\/cart/.test(path)) return 'cart';
    if (/^\/checkout/.test(path)) return 'checkout';
    return 'page';
  }

  function firstAttribute(node, attributes) {
    var current = node;
    for (var i = 0; i < attributes.length; i += 1) {
      if (current && current.getAttribute) {
        var value = safe(current.getAttribute(attributes[i]));
        if (value) return value;
      }
    }
    return '';
  }

  function nearestAttribute(node, attribute) {
    if (!node || !node.closest) return '';
    var match = node.closest('[' + attribute + ']');
    return match ? safe(match.getAttribute(attribute)) : '';
  }

  function entityMetadata(target) {
    var node = target && target.closest ? target.closest('[data-cl-entity-id]') : null;
    if (!node && campaign() === 'head_trip') node = document.querySelector('[data-cl-entity-id="head-trip-2026"]');
    var type = firstAttribute(node, ['data-cl-entity-type']);
    var entityId = firstAttribute(node, ['data-cl-entity-id']);
    var status = firstAttribute(node, ['data-cl-entity-status']);
    var start = firstAttribute(node, ['data-cl-event-start']);
    var end = firstAttribute(node, ['data-cl-event-end']);
    var restockWindow = firstAttribute(node, ['data-cl-restock-window']);
    return {
      entity_type: safe(type),
      entity_id: safe(entityId),
      entity_status: safe(status),
      event_start_at: safe(start),
      event_end_at: safe(end),
      restock_window: safe(restockWindow)
    };
  }

  function campaign() {
    // A promotion elsewhere on the page is not evidence of the visitor's topic.
    // Clicks use their own nearest campaign marker; page activity uses its path.
    var handle = pageHandle().toLowerCase();
    if (handle.indexOf('head-trip') !== -1) return 'head_trip';
    if (/collection[-_]?003|drop[-_]?003/.test(handle)) return 'collection_003';
    if (/music|song|release|discography|tracks?/.test(handle)) return 'music';
    if (/network|community|discord/.test(handle)) return 'network';
    if (/show|tour|ticket|^live$/.test(handle)) return 'tickets';
    return 'site';
  }

  function currentAttribution(target) {
    if (!isProduction() || !marketingAllowed()) return {};
    var stored = readStorage(ATTRIBUTION_KEY);
    var now = Date.now();
    if (!stored.started || now - stored.touched > MAX_AGE) stored = {started: now, first: {}, last: {}};
    if (!stored.first) stored.first = {};
    if (!stored.last) stored.last = {};

    var sources = [];
    try { sources.push(new URL(window.location.href)); } catch (error) {}

    var current = {};
    sources.forEach(function (source) {
      UTM_KEYS.forEach(function (key) {
        var value = safe(source.searchParams.get(key));
        if (value) current[key] = value;
      });
    });

    if (Object.keys(current).length) {
      if (!Object.keys(stored.first).length) stored.first = Object.assign({}, current);
      stored.last = Object.assign({}, current);
    }
    stored.touched = now;
    writeStorage(ATTRIBUTION_KEY, stored);
    // Share consented landing attribution with The Network's 30-minute session.
    if (Object.keys(current).length) {
      var networkAttribution = readStorage('cl_network_attribution_v2');
      if (!Number.isFinite(networkAttribution.started) || !Number.isFinite(networkAttribution.touched) || now - networkAttribution.touched > 1800000 || now < networkAttribution.touched) networkAttribution = {started: now, first: {}, last: {}};
      var networkCurrent = {};
      UTM_KEYS.forEach(function (key) { var value = current[key]; if (value && value.length <= 150 && /^[a-zA-Z0-9._~ -]+$/.test(value)) networkCurrent[key] = value; });
      if (Object.keys(networkCurrent).length) {
        if (!networkAttribution.first || !Object.keys(networkAttribution.first).length) networkAttribution.first = Object.assign({}, networkCurrent);
        networkAttribution.last = Object.assign({}, networkCurrent);
        networkAttribution.touched = now;
        writeStorage('cl_network_attribution_v2', networkAttribution);
      }
    }

    var result = {};
    UTM_KEYS.forEach(function (key) {
      if (stored.last[key]) result[key] = stored.last[key];
    });
    return result;
  }

  function identifyFromQueue() {
    try {
      var queue = window._learnq;
      if (!Array.isArray(queue)) return '';
      for (var i = queue.length - 1; i >= 0; i -= 1) {
        var item = queue[i];
        if (!Array.isArray(item) || item[0] !== 'identify') continue;
        var data = item[1] || {};
        var email = validEmail(data.$email || data.email || data.email_address);
        if (email) return email;
      }
    } catch (error) {}
    return '';
  }

  function emailFromForm(form) {
    if (!form || !form.elements) return '';
    var field = form.elements.email || form.elements.email_address || form.querySelector('input[type="email"]');
    return validEmail(field && field.value);
  }

  function profileEmail(form) {
    return validEmail(window.__CL_PROFILE_EMAIL__) || identifyFromQueue();
  }

  function consentState(form, eventType) {
    var state = {email: false, sms: false, source: 'website_signal'};
    if (eventType !== 'form_submitted' || !form || !form.querySelector) return state;
    var emailConsent = form.querySelector('input[name="email_consent"]');
    var smsConsent = form.querySelector('input[name="sms_consent"]');
    state.email = Boolean(emailConsent && emailConsent.checked);
    state.sms = Boolean(smsConsent && smsConsent.checked);
    state.source = form.matches && form.matches('[data-cl-network-form]') ? 'network_form' : 'website_form';
    return state;
  }

  function signalForm(form) {
    if (!form || !form.matches) return false;
    if (form.matches('form[data-cl-signal-form], form[data-cl-event-form], form[data-cl-network-form]')) return true;
    var action = safe(form.getAttribute('action')).toLowerCase();
    if (/\/account\/login|\/search/.test(action)) return false;
    return Boolean(form.querySelector('input[type="email"], input[name="email"], input[name="email_address"]'));
  }

  function linkFor(target) {
    var link = target && target.closest ? target.closest('a[href]') : null;
    return link || null;
  }

  function buttonFor(target) {
    var button = target && target.closest ? target.closest('button, [role="button"]') : null;
    if (!button) return null;
    if (button.hasAttribute('data-cl-event') || button.hasAttribute('data-cl-product-id') || button.hasAttribute('data-cl-network-open')) return button;
    return null;
  }

  function eventTypeFor(link) {
    if (!link) return '';
    var explicit = safe(link.getAttribute('data-cl-event'));
    var contentType = firstAttribute(link, ['data-cl-content-type', 'data-cl-media-kind']).toLowerCase();
    var raw = firstAttribute(link, ['data-cl-product-url', 'data-cl-destination', 'data-cl-url', 'href']);
    var href = '';
    try { href = new URL(raw || window.location.href, window.location.href).href; } catch (error) { return ''; }

    if (explicit === 'laylo_fallback_click') return 'laylo_click';
    if (firstAttribute(link, ['data-cl-product-id'])) return 'product_click';
    if (explicit === 'youtube_click') return 'youtube_click';
    if (explicit === 'song_click') return 'music_click';
    if (['ticket_click', 'laylo_click', 'livestream_click', 'campaign_click', 'page_click', 'page_engaged', 'interest_selected', 'page_left', 'product_click', 'show_click', 'music_click', 'song_click', 'network_click', 'network_discord_clicked'].indexOf(explicit) !== -1) return explicit;
    if (contentType === 'song' || contentType === 'track') return 'music_click';
    if (contentType === 'music' || contentType === 'audio' || contentType === 'release') return 'music_click';
    var destinationUrl = new URL(href);
        if (/(^|\.)(lnk\.to|snd\.click|found\.ee|cobrand\.com)$/.test(destinationUrl.hostname)) return 'music_click';
            if (/(^|\.)seated\.com$/.test(destinationUrl.hostname)) return 'ticket_click';
                if (HOSTS.indexOf(destinationUrl.hostname) !== -1 && /^\/pages\/join(?:\/|$)/.test(destinationUrl.pathname)) return 'network_click';
                    if (HOSTS.indexOf(destinationUrl.hostname) !== -1 && /^\/pages\/music(?:\/|$)/.test(destinationUrl.pathname)) return 'music_click';
                        if (HOSTS.indexOf(destinationUrl.hostname) !== -1 && /^\/pages\/live(?:\/|$)/.test(destinationUrl.pathname)) return 'show_click';
                            if (/axs\.com/i.test(href)) return 'ticket_click';
    if (/laylo\.com/i.test(href)) return 'laylo_click';
    if (/discord\.com|discord\.gg/i.test(href)) return 'network_discord_clicked';
    if (/spotify\.com|music\.apple\.com|soundcloud\.com|beatport\.com|tidal\.com|music\.amazon\.com|bandcamp\.com/i.test(href)) return 'music_click';
    if (/youtube\.com|youtu\.be/i.test(href)) return 'youtube_click';
    if (/vimeo\.com|twitch\.tv/i.test(href)) return 'livestream_click';
    if (/\/products\//i.test(href)) return 'product_click';
    if (/\/collections\//i.test(href)) return 'product_click';
    if (/head-trip-2026-live-stream|#head-trip-live/i.test(href)) return 'livestream_click';
    if (/head-trip-2026-tickets|\/pages\/shows|\/pages\/tour/i.test(href)) return 'show_click';
    if (/^https:\/\/(www\.)?chris-lake\.com\/pages\//i.test(href)) return 'page_click';
    if (explicit === 'campaign_click') return 'campaign_click';
    return '';
  }

  function cleanUrl(raw) {
    if (typeof raw !== 'string' || !raw.trim()) return '';
    try {
      var url = new URL(raw, window.location.href);
      if (url.protocol !== 'https:' || url.username || url.password) return '';
      var query = [];
      UTM_KEYS.forEach(function (key) {
        var value = safe(url.searchParams.get(key));
        if (value) query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      // Keep public content identifiers needed to reopen the selected item.
      // Recovery, subscription and identity tokens do not belong in telemetry.
      var publicParams = {};
      if (/^(www\.)?youtube\.com$/.test(url.hostname) && url.pathname === '/watch') {
        publicParams.v = /^[A-Za-z0-9_-]{11}$/;
      }
      if (HOSTS.indexOf(url.hostname) !== -1 && /\/products\//.test(url.pathname)) {
        publicParams.variant = /^\d+$/;
        publicParams.selling_plan = /^\d+$/;
      }
      Object.keys(publicParams).forEach(function (key) {
        var value = url.searchParams.get(key) || '';
        if (publicParams[key].test(value)) query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var fragment = HOSTS.indexOf(url.hostname) !== -1 && /^#[A-Za-z][A-Za-z0-9_-]{0,95}$/.test(url.hash) ? url.hash : '';
      return url.origin + url.pathname + (query.length ? '?' + query.join('&') : '') + fragment;
    } catch (error) { return ''; }
  }

  function linkDestination(link) {
    if (!link) return '';
    var raw = firstAttribute(link, ['data-cl-product-url', 'data-cl-destination', 'data-cl-url', 'href']);
    return cleanUrl(raw || window.location.href);
  }

  function pageMetadata(target) {
    var canonical = document.querySelector('link[rel="canonical"]');
    var description = document.querySelector('meta[name="description"]');
    var eventNameMeta = document.querySelector('meta[itemprop="name"]');
    var eventCityMeta = document.querySelector('meta[itemprop="addressLocality"]');
    var eventRegionMeta = document.querySelector('meta[itemprop="addressRegion"]');
    var eventCountryMeta = document.querySelector('meta[itemprop="addressCountry"]');
    var productHandle = firstAttribute(target, ['data-cl-product-handle']);
    var productVariantId = firstAttribute(target, ['data-cl-product-variant-id']);
    var collectionHandle = firstAttribute(target, ['data-cl-collection', 'data-cl-collection-handle']);
    var collectionTitle = firstAttribute(target, ['data-cl-collection-title']);
    var showId = firstAttribute(target, ['data-cl-show-id']);
    var showName = firstAttribute(target, ['data-cl-show-name']) || safe(eventNameMeta && eventNameMeta.getAttribute('content'));
    var showCity = firstAttribute(target, ['data-cl-show-city', 'data-cl-location-city']) || safe(eventCityMeta && eventCityMeta.getAttribute('content'));
    var showRegion = firstAttribute(target, ['data-cl-show-region', 'data-cl-location-region']) || safe(eventRegionMeta && eventRegionMeta.getAttribute('content'));
    var showCountry = firstAttribute(target, ['data-cl-show-country', 'data-cl-location-country']) || safe(eventCountryMeta && eventCountryMeta.getAttribute('content'));
    var ticketVendor = firstAttribute(target, ['data-cl-ticket-vendor']);
    var songTitle = firstAttribute(target, ['data-cl-song-title', 'data-cl-track-title']);
    var artistAlias = firstAttribute(target, ['data-cl-artist', 'data-cl-artist-alias']);
    if (!productHandle) productHandle = nearestAttribute(target, 'data-cl-product-handle');
    if (!productVariantId) productVariantId = nearestAttribute(target, 'data-cl-product-variant-id');
    if (!collectionHandle) collectionHandle = nearestAttribute(target, 'data-cl-collection');
    if (!collectionTitle) collectionTitle = nearestAttribute(target, 'data-cl-collection-title');
    if (!showId) showId = nearestAttribute(target, 'data-cl-show-id');
    if (!showName) showName = nearestAttribute(target, 'data-cl-show-name');
    if (!showCity) showCity = nearestAttribute(target, 'data-cl-show-city');
    if (!showRegion) showRegion = nearestAttribute(target, 'data-cl-show-region');
    if (!showCountry) showCountry = nearestAttribute(target, 'data-cl-show-country');
    if (!ticketVendor) ticketVendor = nearestAttribute(target, 'data-cl-ticket-vendor');
    if (!songTitle) songTitle = nearestAttribute(target, 'data-cl-song-title');
    if (!artistAlias) artistAlias = nearestAttribute(target, 'data-cl-artist');
    if (!productHandle) {
      var productMatch = window.location.pathname.match(/\/products\/([^/?#]+)/i);
      productHandle = productMatch ? productMatch[1] : '';
    }
    if (!collectionHandle) {
      var collectionMatch = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
      collectionHandle = collectionMatch ? collectionMatch[1] : '';
    }
    return {
      page_type: pageType(),
      content_type: firstAttribute(target, ['data-cl-content-type']) || pageType(),
      page_title: safe(document.title),
      page_path: safe(window.location.pathname),
      canonical_url: safe(canonical && canonical.href),
      seo_title: safe(document.title),
      seo_description: safe(description && description.getAttribute('content')),
      product_handle: productHandle,
      product_variant_id: productVariantId,
      collection_handle: collectionHandle,
      collection_title: collectionTitle,
      show_id: showId,
      show_name: showName,
      show_city: showCity,
      show_region: showRegion,
      show_country: showCountry,
      ticket_vendor: ticketVendor,
      song_title: songTitle,
      artist_alias: artistAlias
    };
  }

  function locationMetadata(target, metadata) {
    var city = metadata.show_city || firstAttribute(target, ['data-cl-location-city']) || safe(window.__CL_LOCATION_CITY__);
    var region = metadata.show_region || firstAttribute(target, ['data-cl-location-region']) || safe(window.__CL_LOCATION_REGION__);
    var country = metadata.show_country || firstAttribute(target, ['data-cl-location-country']) || safe(window.__CL_LOCATION_COUNTRY__) || '';
    var timezone = '';
    try { timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (error) {}
    return {
      city: city,
      region: region,
      country: country,
      timezone: safe(timezone),
      source: city || region ? 'page_metadata' : 'shopify'
    };
  }

  function activePageMilliseconds() {
    return activeElapsedMs + (activeStartedAt === null ? 0 : Math.max(0, Date.now() - activeStartedAt));
  }

  function pauseActiveClock() {
    if (activeStartedAt === null) return;
    activeElapsedMs = activePageMilliseconds();
    activeStartedAt = null;
  }

  function resumeActiveClock() {
    if (activeStartedAt === null) activeStartedAt = Date.now();
    scheduleQualifiedEngagement();
  }

  function scheduleQualifiedEngagement() {
    if (engaged || document.visibilityState === 'hidden' || activeStartedAt === null) return;
    if (engagementTimer) window.clearTimeout(engagementTimer);
    var remaining = Math.max(0, 30000 - activePageMilliseconds());
    engagementTimer = window.setTimeout(function () {
      engagementTimer = null;
      qualifiedEngagement();
    }, remaining);
  }

  function elapsedSeconds() {
    return Math.max(0, Math.floor(activePageMilliseconds() / 1000));
  }

  function scrollDepthPercent() {
    var height = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    if (!height) return 0;
    return Math.max(0, Math.min(100, Math.round(((window.scrollY + window.innerHeight) / height) * 100)));
  }

  function signalPayload(eventType, details, form, target, reason) {
    var email = profileEmail(form);
    if (!isProduction() || !marketingAllowed()) return null;

    var metadata = pageMetadata(target);
    var entity = entityMetadata(target);
    var destination = linkDestination(target);
    var pageUrl = cleanUrl(window.location.href) || (window.location.origin + window.location.pathname);
    var contextCampaign = safe((details && details.campaign) || nearestAttribute(target, 'data-cl-campaign') || campaign());
    if (contextCampaign === 'head_trip_2026') contextCampaign = 'head_trip';
        if (contextCampaign !== 'head_trip' && contextCampaign !== 'collection_003') {
                if (eventType === 'ticket_click' || eventType === 'show_click') contextCampaign = 'tickets';
                      if (eventType === 'music_click') contextCampaign = 'music';
                            if (eventType === 'network_click') contextCampaign = 'network';
                                }
                                    if (eventType === 'music_click' && !metadata.song_title && target && /\/pages\/music(?:\/|$)/.test(window.location.pathname) && !/^https:\/\/(www\.)?chris-lake\.com\//.test(destination)) metadata.song_title = safe(target.getAttribute('aria-label') || target.textContent);
    var clickTarget = safe((details && details.click_target) || (target && (target.getAttribute('aria-label') || target.textContent)));
    var eventUrl = cleanUrl((details && details.url) || destination || pageUrl);
    var elapsed = elapsedSeconds();
    var consent = consentState(form, eventType);
    var payload = {
      schema_version: 'cl2026.v2',
      build: BUILD,
      event_id: id(),
      event_type: eventType,
      occurred_at: new Date().toISOString(),
      profile: {email: email},
      context: {
        campaign: contextCampaign,
        page_handle: pageHandle(),
        page_url: pageUrl,
        page_type: metadata.page_type,
        content_type: safe((details && details.content_type) || metadata.content_type),
        page_title: metadata.page_title,
        page_path: metadata.page_path,
        canonical_url: metadata.canonical_url,
        seo_title: metadata.seo_title,
        seo_description: metadata.seo_description,
        placement: safe((details && details.placement) || firstAttribute(target, ['data-cl-placement']) || eventType),
        source: 'chris-lake.com',
        referrer: cleanUrl(document.referrer),
        interest: safe((details && details.interest) || firstAttribute(target, ['data-cl-interest']) || ((eventType === 'ticket_click' || eventType === 'show_click') ? 'tickets_shows' : (eventType === 'music_click' || eventType === 'youtube_click') ? 'music' : eventType === 'product_click' ? 'merch' : '')),
        page_item: metadata.page_type + ':' + (metadata.product_handle || metadata.collection_handle || metadata.show_id || pageHandle()),
        show_id: metadata.show_id,
        show_name: metadata.show_name,
        show_city: metadata.show_city,
        show_region: metadata.show_region,
        show_country: metadata.show_country,
        ticket_vendor: metadata.ticket_vendor,
        song_title: metadata.song_title,
        artist_alias: metadata.artist_alias,
        collection_title: metadata.collection_title,
        location: locationMetadata(target, metadata),
        entity_type: entity.entity_type,
        entity_id: entity.entity_id,
        entity_status: entity.entity_status,
        event_start_at: entity.event_start_at,
        event_end_at: entity.event_end_at,
        restock_window: entity.restock_window
      },
      utm: currentAttribution(eventUrl),
      event: {
        destination: cleanUrl((details && details.destination) || destination),
        url: eventUrl,
        link_text: clickTarget,
        click_target: clickTarget,
        drop_id: safe((details && details.drop_id) || firstAttribute(target, ['data-cl-drop-id'])),
        product_id: safe((details && details.product_id) || firstAttribute(target, ['data-cl-product-id']) || nearestAttribute(target, 'data-cl-product-id') || nearestAttribute(target, 'data-product-id')),
        product_title: safe((details && details.product_title) || firstAttribute(target, ['data-cl-product-title'])),
        product_handle: metadata.product_handle,
        product_variant_id: metadata.product_variant_id,
        collection_handle: metadata.collection_handle,
        collection_title: metadata.collection_title,
        page_type: metadata.page_type,
        content_type: metadata.content_type,
        show_id: metadata.show_id,
        show_name: metadata.show_name,
        show_city: metadata.show_city,
        show_region: metadata.show_region,
        show_country: metadata.show_country,
        ticket_vendor: metadata.ticket_vendor,
        song_title: metadata.song_title,
        artist_alias: metadata.artist_alias,
        video_id: safe((details && details.video_id) || firstAttribute(target, ['data-cl-video-id'])),
        video_title: safe((details && details.video_title) || firstAttribute(target, ['data-cl-video-title'])),
        video_url: cleanUrl((details && details.video_url) || ''),
        video_percent: Number(details && details.video_percent) > 0 ? Number(details.video_percent) : 0,
        video_threshold: safe((details && details.video_threshold) || ''),
        form_id: safe((details && details.form_id) || (form && form.id)),
        page_left_reason: safe(reason || (details && details.page_left_reason)),
        duration_seconds: elapsed,
        time_on_page_seconds: elapsed,
        engagement_seconds: eventType === 'page_engaged' || engaged ? elapsed : null,
        qualified_engagement: Boolean(eventType === 'page_engaged' || engaged),
        scroll_depth_percent: scrollDepthPercent()
      },
      consent: consent
    };
    return payload;
  }

  var DIRECT_ROUTES = [{"name":"CL | Head Trip | Ticket Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}]]},{"name":"CL | Head Trip | Laylo Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"collection_003"}]]},{"name":"CL | Head Trip | Livestream Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}]]},{"name":"CL | Head Trip | Campaign Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"collection_003"}]]},{"name":"CL | Head Trip | Page Engagement","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"collection_003"}]]},{"name":"CL | Head Trip | Interest Selected","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}]]},{"name":"CL | Head Trip | Form Submitted","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"collection_003"}]]},{"name":"CL | Head Trip | Page Left","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}]]},{"name":"CL | Head Trip | Product Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"collection_003"}]]},{"name":"CL | Head Trip | Show Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"}]]},{"name":"CL | Web | Page Viewed","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_viewed"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | YouTube Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"youtube_click"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Music Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"music_click"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Discord Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"network_discord_clicked"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Network Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"network_click"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Ticket Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"ticket_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Laylo Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"laylo_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Livestream Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"livestream_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Campaign Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"campaign_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Page Engagement","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"music"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"network"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"general"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_engaged"},{"path":["context","campaign"],"operator":"text:equal","value":"site"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Interest Selected","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"interest_selected"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Form Submitted","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"music"}],[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"network"}],[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"}],[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"general"}],[{"path":["event_type"],"operator":"text:equal","value":"form_submitted"},{"path":["context","campaign"],"operator":"text:equal","value":"site"}]]},{"name":"CL | Web | Page Left","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"music"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"network"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"general"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"page_left"},{"path":["context","campaign"],"operator":"text:equal","value":"site"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Product Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"product_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Show Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"music"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"network"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"tickets"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"general"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}],[{"path":["event_type"],"operator":"text:equal","value":"show_click"},{"path":["context","campaign"],"operator":"text:equal","value":"site"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Web | Page Click","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"page_click"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL | Head Trip | Restock Merge Ready","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"restock_merge_ready"},{"path":["context","campaign"],"operator":"text:equal","value":"head_trip"},{"path":["context","entity_id"],"operator":"text:equal","value":"head-trip-2026"},{"path":["context","entity_status"],"operator":"text:equal","value":"post_event"},{"path":["context","restock_window"],"operator":"text:equal","value":"post_event"}]]},{"name":"CL | Web | Video Watched","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"video_watched"},{"path":["context","campaign"],"operator":"text:notequal","value":"head_trip"}]]},{"name":"CL_POD_Fan_Favorites_Intent","conditions":[[{"path":["event_type"],"operator":"text:equal","value":"CL_POD_Fan_Favorites_Intent"},{"path":["context","collection_handle"],"operator":"text:equal","value":"fan-favorites"},{"path":["context","collection_id"],"operator":"text:equal","value":"gid://shopify/Collection/655931965726"},{"path":["event","pod_collection"],"operator":"boolean:equal","value":true}]]}];

  // Public browser endpoint: no private API key, subscription mutation or Make hop.
  var ENDPOINT = 'https://a.klaviyo.com/client/events?company_id=TGB9tG';
  var inFlight = Object.create(null);
  var accepted = Object.create(null);

  function metricFor(payload) {
    var candidates = DIRECT_ROUTES.filter(function (route) {
      return route.conditions.some(function (group) {
        return group.every(function (condition) {
          var value = condition.path.reduce(function (v, key) { return v && v[key]; }, payload);
          return condition.operator === 'text:notequal' ? value !== condition.value : value === condition.value;
        });
      });
    });
    // Ambiguous routing must never fan one action into competing journeys.
    return candidates.length === 1 ? candidates[0].name : '';
  }

  function eventProperties(payload) {
    var properties = Object.assign({}, payload.context, payload.event, payload.utm, {
      schema_version: payload.schema_version,
      build: BUILD,
      transport: 'klaviyo_direct',
      event_id: payload.event_id,
      event_type: payload.event_type,
      occurred_at: payload.occurred_at,
      email_consent: payload.consent.email,
      sms_consent: payload.consent.sms,
      consent_source: payload.consent.source
    });
    var location = properties.location || {};
    ['city', 'region', 'country', 'timezone'].forEach(function (key) { properties[key] = location[key] || ''; });
    properties.location_source = location.source || '';
    delete properties.location;
    return properties;
  }

  function retryDelay(response, attempt) {
    var raw = response && response.headers && response.headers.get('Retry-After');
    var seconds = Number(raw);
    if (raw && !Number.isFinite(seconds)) seconds = (Date.parse(raw) - Date.now()) / 1000;
    return raw && Number.isFinite(seconds) && seconds > 0
      ? Math.min(seconds * 1000, 3600000)
      : Math.min(1000 * Math.pow(2, attempt), 30000);
  }

  function requestDirect(payload, metric, properties) {
    if (payload.profile.email) {
      return fetch(ENDPOINT, {
        method: 'POST', mode: 'cors', credentials: 'omit', keepalive: true,
        headers: {'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15'},
        body: JSON.stringify({data: {type: 'event', attributes: {
          unique_id: payload.event_id,
          time: payload.occurred_at,
          metric: {data: {type: 'metric', attributes: {name: metric}}},
          profile: {data: {type: 'profile', attributes: {email: payload.profile.email}}},
          properties: properties
        }}})
      }).then(function (response) {
        return {accepted: response.status === 202, retry: response.status === 429 || response.status >= 500, response: response};
      });
    }
    // Let Klaviyo resolve an existing browser identity; do not scrape its cookies
    // or collect an email from an unsubmitted form.
    var sdk = window.klaviyo;
    if (!sdk || typeof sdk.isIdentified !== 'function' || typeof sdk.track !== 'function') {
      return Promise.resolve({accepted: false, retry: true});
    }
    return Promise.resolve(sdk.isIdentified()).then(function (identified) {
      if (identified !== true || !isProduction() || !marketingAllowed()) return {accepted: false, retry: false};
      return Promise.resolve(sdk.track(metric, Object.assign({}, properties, {$event_id: payload.event_id})))
        .then(function (result) { return {accepted: result === true, retry: result !== true}; });
    });
  }

  function deliver(payload) {
    if (!payload || !isProduction() || !marketingAllowed()) return;
    var metric = metricFor(payload);
    if (!metric) return;
    var target = payload.event.video_id || payload.event.destination || payload.event.url;
    if (payload.event.form_id) target = payload.event.form_id + '|' + (payload.event.submission_id || '') + '|' + target;
    var key = payload.event_type === 'CL_POD_Fan_Favorites_Intent'
      ? ['fan_favorites', payload.event.product_id || payload.context.collection_id].join('|')
      : [payload.event_type, payload.context.campaign, payload.context.page_path, target].join('|');
    var ledger = readStorage(SENT_KEY);
    if (accepted[key] || ledger[key] && ledger[key].status === 'accepted' || inFlight[key]) return;
    var previous = ledger[key];
    if (previous && previous.id && previous.time) {
      payload.event_id = previous.id;
      payload.occurred_at = previous.time;
    }
    // Keep only the event receipt in session storage. No email or payload is stored.
    ledger[key] = {id: payload.event_id, time: payload.occurred_at, status: 'pending'};
    var keys = Object.keys(ledger);
    if (keys.length > 150) delete ledger[keys[0]];
    writeStorage(SENT_KEY, ledger);
    inFlight[key] = true;
    var properties = eventProperties(payload);
    var attempts = 0;
    function attempt() {
      if (!isProduction() || !marketingAllowed()) { delete inFlight[key]; return; }
      attempts += 1;
      Promise.resolve().then(function () { return requestDirect(payload, metric, properties); })
        .catch(function () { return {accepted: false, retry: true}; })
        .then(function (result) {
          if (result.accepted) {
            accepted[key] = true;
            var current = readStorage(SENT_KEY);
            current[key] = {id: payload.event_id, time: payload.occurred_at, status: 'accepted'};
            writeStorage(SENT_KEY, current);
            delete inFlight[key];
          } else if (result.retry && attempts < 4 && marketingAllowed()) {
            window.setTimeout(attempt, retryDelay(result.response, attempts - 1));
          } else {
            delete inFlight[key];
          }
        });
    }
    attempt();
  }

  function emit(eventType, details, form, target, reason, useBeacon) {
    deliver(signalPayload(eventType, details || {}, form, target, reason));
  }


  function acceptedNetworkRequest(event) {
    var form = event && event.target;
    var root = form && form.closest ? form.closest('[data-cl-network-direct]') : null;
    var receipt = event && event.detail;
    if (form && form.closest && form.closest('[data-cl-network-scratch]')) return;
    if (root && root.getAttribute('data-variant') === 'network_scratch_popup') return;
    if (!root || !form.matches || !form.matches('form') || !receipt || receipt.version !== 1) return;
    if (root.getAttribute('data-theme-id') !== THEME_ID || root.getAttribute('data-site-id') !== 'TGB9tG') return;
    if (!/^[a-zA-Z0-9-]{8,100}$/.test(receipt.submission_id || '') || ['email', 'sms'].indexOf(receipt.channel) === -1) return;
    if (receipt.status !== 202 || !validEmail(receipt.email)) return;
    var payload = signalPayload('form_submitted', {form_id:form.id,placement:root.getAttribute('data-placement') || 'network_form'}, null, form);
    if (!payload) return;
    // Only an accepted explicit request can supply a new identity. No form-field scraping.
    payload.profile.email = validEmail(receipt.email);
    if (isProduction() && marketingAllowed()) {
      window.__CL_PROFILE_EMAIL__ = payload.profile.email;
      var identifyAccepted = function (attempt) {
        if (!isProduction() || !marketingAllowed()) return;
        var sdk = window.klaviyo;
        if (!sdk || typeof sdk.identify !== 'function') {
          if (attempt < 10) window.setTimeout(function () { identifyAccepted(attempt + 1); }, 500);
          return;
        }
        Promise.resolve(sdk.identify({email: payload.profile.email})).then(function () { emitPageViewed(); }).catch(function () {});
      };
      identifyAccepted(0);
    }
    payload.event_id = 'cl-network-' + receipt.submission_id;
    payload.event.submission_id = receipt.submission_id;
    payload.event.accepted_channel = receipt.channel;
    payload.event.request_status = 'accepted_not_delivery_verified';
    payload.consent.source = 'network_request_accepted';
    payload.consent.email = receipt.channel === 'email';
    payload.consent.sms = receipt.channel === 'sms';
    deliver(payload);
  }

  function fanFavoritesIntent() {
    var node = document.querySelector('[data-cl-fan-context]');
    if (!node || node.getAttribute('data-cl-collection-id') !== '655931965726' || node.getAttribute('data-cl-collection-handle') !== 'fan-favorites') return false;
    // This replaces the generic engagement event after the same foreground-time threshold.
    var payload = signalPayload('CL_POD_Fan_Favorites_Intent', {placement:'fan_favorites_qualified_engagement',campaign:'fan_favorites'}, null, node);
    if (!payload) return true;
    payload.context.collection_id = 'gid://shopify/Collection/655931965726';
    payload.context.collection_handle = 'fan-favorites';
    payload.context.collection_title = 'Fan Favorites';
    payload.event.collection_id = payload.context.collection_id;
    payload.event.collection_handle = 'fan-favorites';
    payload.event.pod_collection = true;
    payload.event.qualified_engagement = true;
    payload.event.product_id = node.getAttribute('data-cl-product-id') || '';
    payload.event.product_title = safe(node.getAttribute('data-cl-product-title'));
    var productPath = node.getAttribute('data-cl-product-url') || '';
    payload.event.product_url = /^\/products\/[a-z0-9-]+$/.test(productPath) ? window.location.origin + productPath : '';
    var image = node.getAttribute('data-cl-product-image') || '';
    if (image.indexOf('//') === 0) image = 'https:' + image;
    ['https://chris-lake.com/cdn/shop/files/', 'https://www.chris-lake.com/cdn/shop/files/'].forEach(function (prefix) {
      if (image.indexOf(prefix) === 0) image = 'https://cdn.shopify.com/s/files/1/0924/7408/1566/files/' + image.slice(prefix.length);
    });
    payload.event.product_image_url = image.indexOf('https://cdn.shopify.com/') === 0 ? image : '';
    deliver(payload);
    return true;
  }

  document.addEventListener('cl:network-request-accepted', acceptedNetworkRequest);

  function videoWatched(event) {
    var video = event && event.target;
    if (!video || video.tagName !== 'VIDEO' || video.__clVideoWatched) return;
    var current = Number(video.currentTime) || 0;
    var duration = Number(video.duration) || 0;
    var reached = current >= VIDEO_THRESHOLD_SECONDS || (isFinite(duration) && duration > 0 && current / duration >= VIDEO_THRESHOLD_PERCENT);
    if (!reached) return;
    video.__clVideoWatched = true;
    emit('video_watched', {
      placement: 'video_watch_threshold',
      content_type: video.getAttribute('data-cl-content-type') || 'video',
      video_id: video.getAttribute('data-cl-video-id') || video.currentSrc || video.getAttribute('src') || 'video',
      video_title: video.getAttribute('data-cl-video-title') || video.getAttribute('aria-label') || video.getAttribute('title') || 'video',
      video_url: video.currentSrc || video.getAttribute('src') || '',
      video_percent: isFinite(duration) && duration > 0 ? Math.round((current / duration) * 100) : 0,
      video_threshold: current >= VIDEO_THRESHOLD_SECONDS ? '30_seconds' : '50_percent'
    }, null, video);
  }

  function qualifiedEngagement() {
    if (!isProduction() || !marketingAllowed() || engaged || document.visibilityState === 'hidden' || activeStartedAt === null) return;
    if (activePageMilliseconds() < 30000) return;
    engaged = true;
    if (engagementTimer) {
      window.clearTimeout(engagementTimer);
      engagementTimer = null;
    }
    if (!fanFavoritesIntent()) emit('page_engaged', {placement: 'qualified_page_engagement', click_target: '30_seconds_active_foreground'});
  }

  function emitPageViewed() {
    emit('page_viewed', {placement: 'page_view', url: window.location.href, click_target: pageType()});
  }

  

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest('[data-cl-network-scratch]')) return;
    var link = linkFor(event.target);
    var tracked = link || buttonFor(event.target);
    var eventType = eventTypeFor(tracked);
    if (!tracked || !eventType) {
      var interestButton = event.target && event.target.closest ? event.target.closest('[data-cl-network-open]') : null;
      var interestHost = interestButton && interestButton.closest ? interestButton.closest('[data-cl-interest]') : null;
      var interest = firstAttribute(interestHost || interestButton, ['data-cl-interest', 'data-cl-network-context']);
      if (!interest) return;
      emit('interest_selected', {placement: 'interest_selector', interest: interest, click_target: interest}, null, interestHost || interestButton);
      return;
    }
    navigating = true;
    window.setTimeout(function () { navigating = false; }, 1500);
    emit(eventType, {
      placement: tracked.getAttribute('data-cl-placement') || eventType,
      campaign: nearestAttribute(tracked, 'data-cl-campaign') || campaign(),
      content_type: tracked.getAttribute('data-cl-content-type') || '',
      destination: linkDestination(tracked),
      url: linkDestination(tracked),
      click_target: (tracked.getAttribute('aria-label') || tracked.textContent || '').trim()
    }, null, tracked);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input && input.closest && input.closest('[data-cl-network-scratch]')) return;
    if (!input || !input.matches || !input.matches('[data-cl-interest], input[name="network_interests"], input[name="interest"]')) return;
    emit('interest_selected', {
      placement: input.getAttribute('data-cl-placement') || 'interest_selector',
      interest: input.value,
      click_target: input.value
    }, input.form, null);
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      pauseActiveClock();
      if (engagementTimer) {
        window.clearTimeout(engagementTimer);
        engagementTimer = null;
      }
      if (hiddenTimer) window.clearTimeout(hiddenTimer);
      hiddenTimer = window.setTimeout(function () {
        hiddenTimer = null;
        if (leftSent || navigating) return;
        leftSent = true;
        emit('page_left', {placement: 'page_exit'}, null, null, 'visibility_hidden', true);
      }, 1500);
    } else {
      if (hiddenTimer) {
        window.clearTimeout(hiddenTimer);
        hiddenTimer = null;
      }
      resumeActiveClock();
    }
  });

  window.addEventListener('pagehide', function () {
    pauseActiveClock();
    if (engagementTimer) {
      window.clearTimeout(engagementTimer);
      engagementTimer = null;
    }
    if (hiddenTimer) {
      window.clearTimeout(hiddenTimer);
      hiddenTimer = null;
    }
    if (leftSent || navigating) return;
    leftSent = true;
    emit('page_left', {placement: 'page_exit'}, null, null, 'pagehide', true);
  }, {capture: true});

  document.addEventListener('timeupdate', videoWatched, true);
  document.addEventListener('ended', videoWatched, true);
  window.addEventListener('scroll', qualifiedEngagement, {passive: true});
  scheduleQualifiedEngagement();
  currentAttribution();
  document.addEventListener('visitorConsentCollected', function () {
    if (marketingAllowed()) { currentAttribution(); emitPageViewed(); if (!engaged) { activeElapsedMs = 0; activeStartedAt = document.visibilityState === 'hidden' ? null : Date.now(); scheduleQualifiedEngagement(); } }
  });
  window.addEventListener('load', currentAttribution, {once: true});
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
      if (!error && marketingAllowed()) { currentAttribution(); emitPageViewed(); }
    });
  }
  window.setTimeout(emitPageViewed, 0);
}());

